import Vue from 'vue'
import App from './App.vue'
import '../src/components/column3/js/lineChart copy'

import './assets/css/font.css'
import './assets/css/flyos.css'

import './plugins/axios'

import * as Echarts from 'echarts'

import dataV from '@jiaminghi/data-view'
Vue.use(dataV)

Vue.config.productionTip = false

Vue.prototype.$echarts = Echarts

const vue = new Vue({
  render: h => h(App),
}).$mount('#app')
export default vue
